import React from 'react';
import RoleDashboardShell from '@/presentation/dashboard/RoleDashboardShell';
import { useRoleDashboardConfig } from '@/presentation/dashboard/useRoleDashboardConfig';
import { useDashboardHomeCopy } from '@/presentation/dashboard/dashboardHomeLocale';
import { useAppTranslation } from '@/i18n/useAppTranslation';
import PublicIeltsQuizSpotlight from '@/presentation/quiz/PublicIeltsQuizSpotlight';

export default function ParentDashboard({ session, onLogout }) {
  const config = useRoleDashboardConfig(session);
  const home = useDashboardHomeCopy(session);
  const { t } = useAppTranslation();
  const userName = session?.user?.name || t('dashboard.guestParentName');

  return (
    <RoleDashboardShell
      session={session}
      appTitle={config.appTitle}
      systemTagline={config.systemTagline}
      roleLabel={config.roleLabel}
      menuItems={config.menuItems}
      onLogout={onLogout}
    >
      <div className="mx-auto max-w-7xl space-y-6">
        <PublicIeltsQuizSpotlight />

        <section className="rounded-3xl border border-slate-100 bg-white p-8 shadow-sm">
          <h1 className="font-headline text-3xl font-extrabold">{home.heroGreeting(userName)}</h1>
          <p className="mt-3 text-slate-600">{home.heroLine}</p>
        </section>

        <div className="grid gap-6 lg:grid-cols-12">
          <article className="rounded-3xl bg-cyan-100 p-7 shadow-sm lg:col-span-8">
            <h2 className="font-headline text-2xl font-extrabold">{home.quoteTitle}</h2>
            <p className="mt-3 max-w-2xl text-slate-700">{home.quoteBody}</p>
            <button type="button" className="mt-5 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-cyan-700">
              {home.sendNote}
            </button>
          </article>

          <article className="rounded-3xl bg-white p-6 shadow-sm lg:col-span-4">
            <h3 className="font-headline text-lg font-bold">{home.yourChildren}</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="rounded-xl border border-slate-100 p-3">
                <p className="font-bold">Minh Anh</p>
                <p className="text-slate-500">{home.child1Status}</p>
              </li>
              <li className="rounded-xl border border-slate-100 p-3">
                <p className="font-bold">Bảo Ngọc</p>
                <p className="text-slate-500">{home.child2Status}</p>
              </li>
            </ul>
          </article>
        </div>

        <article className="rounded-3xl bg-white p-6 shadow-sm">
          <h3 className="font-headline text-xl font-bold">{home.recentQuizzes}</h3>
          <div className="mt-4 grid gap-4 md:grid-cols-3">
            {home.completed.map((item) => (
              <div key={item[0]} className="rounded-xl border border-slate-100 p-4">
                <p className="text-sm font-bold">{item[0]}</p>
                <p className="mt-1 text-xs text-slate-500">{item[1]}</p>
                <p className="mt-2 text-lg font-black text-cyan-700">{item[2]}</p>
              </div>
            ))}
          </div>
        </article>
      </div>
    </RoleDashboardShell>
  );
}

